/* src/app/pages/pop-up/pop-up.component.css */
.popup-container {
  text-align: center;
  height: 100%;
  background: white;
  margin-top: 40px;
  margin-bottom: 40px;
  padding-left: 60px;
  padding-right: 60px;
}
.popup-content {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: center;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.close-button img {
  width: 100%;
  height: 100%;
  display: block;
}
.close-button:focus,
.close-button:focus-visible {
  outline: none;
  box-shadow: none;
}
.aviso {
  height: 105px;
  width: 174px;
}
.popup-image {
  height: 70px;
  width: 70px;
  margin-bottom: 10px;
}
.bold-text {
  font-family: "Gotham Medium";
  color: #323e48;
  font-size: 20px;
  line-height: 25px;
  margin: 0;
}
.normal-text {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  position: relative;
  width: 100%;
  font-family: "Gotham Book";
  color: #5B6670;
  font-size: 15px;
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: center;
  line-height: 20px;
}
.btn {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 18px;
  height: 38px;
  width: 121px;
  padding: 10px 30px;
  background-color: #EB0029;
  color: #FFFFFF;
  border-radius: 4px;
  border: none;
}
.btn:hover {
  background-color: #E30028;
  color: #FFFFFF;
}
.btn:active {
  background-color: #E30028 !important;
  color: #FFFFFF !important;
  box-shadow: inset 0 2px 4px rgba(104, 1, 1, 0.3) !important;
}
::ng-deep .popup-home,
::ng-deep .popup-home .mdc-dialog__surface {
  background: white !important;
  border-radius: 8px !important;
  padding: 0 !important;
  margin: 0 !important;
  width: 100% !important;
  max-width: 720px !important;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/pop-up.component.css.map */
